'use client';

import { includes } from 'lodash-es';
import { useReportWebVitals } from 'next/web-vitals';

export function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    if (!includes(['TTFB', 'FCP', 'LCP', 'INP', 'CLS'], metric.name)) return;

    const body = JSON.stringify({
      name: metric.name,
      value: metric.value,
    });

    const url = `/quantum/vitals`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, body);
    } else {
      fetch(url, { body, method: 'POST', keepalive: true }).catch(() => {});
    }
  });

  return null;
}
